import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Verified Google Reviewer",
    role: "Interior Designer · Bengaluru",
    quote: "Lovely place for interior stuff, they have a huge variety!",
    stars: 5,
  },
  {
    name: "Verified Google Reviewer",
    role: "Property Owner · Bengaluru",
    quote: "He gives you best quality goods for wholesale price. Good customer service and reasonable pricing.",
    stars: 5,
  },
];

function Stars({ n }) {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`h-4 w-4 ${i < n ? "fill-amber-600 text-amber-600" : "text-slate-300"}`} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 lg:py-32 bg-[#FAF8F5]" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: header + rating */}
          <div className="lg:col-span-5">
            <p className="eyebrow mb-4">Social Proof</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-slate-900 font-medium leading-[1.05] tracking-tight">
              What Designers & Property Owners <span className="italic text-amber-700">Say.</span>
            </h2>

            <div className="mt-8 inline-flex items-center gap-5 border border-slate-900/10 bg-white px-6 py-5" data-testid="rating-badge">
              <div className="flex flex-col">
                <span className="font-display text-5xl text-slate-900 leading-none">4.8<span className="text-amber-700">★</span></span>
                <span className="text-xs tracking-[0.2em] uppercase text-slate-500 mt-2">Google Rated</span>
              </div>
              <div className="h-12 w-px bg-slate-300" />
              <div className="text-sm text-slate-600 max-w-[180px] leading-relaxed">
                Verified reviews from architects, designers & property owners across Bengaluru.
              </div>
            </div>
          </div>

          {/* Right: reviews */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6">
            {REVIEWS.map((r) => (
              <article
                key={r.quote}
                className="relative bg-white border border-slate-900/10 p-7 hover:border-amber-700/50 transition-colors duration-500 flex flex-col"
                data-testid={`review-card-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <Quote className="absolute -top-3 left-6 h-8 w-8 text-amber-700 bg-[#FAF8F5] px-1" />
                <Stars n={r.stars} />
                <p className="font-display text-xl md:text-2xl text-slate-900 leading-snug mt-5">
                  {`\u201C${r.quote}\u201D`}
                </p>
                <div className="mt-auto pt-7 border-t border-slate-900/10">
                  <p className="text-sm font-medium text-slate-900">{r.name}</p>
                  <p className="text-xs uppercase tracking-[0.22em] text-slate-500 mt-1">{r.role}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
